// extracted by mini-css-extract-plugin
export default {"card":"Styles_card__gX637"};